/**
 * The wide full-screen column shared by FullScreenModal's `page` width and the
 * screens that clone its layout (Registration Setup, the roster Add/Edit
 * Player editor): capped at this width, with this gutter on each side.
 */
export const FULL_SCREEN_PAGE_MAX_WIDTH = 1600
export const FULL_SCREEN_PAGE_GUTTER = 24
